import {ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit} from '@angular/core';
import {ToolsBoxService} from './Services/tools.service';

import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import {Observable} from "rxjs";
import {NotificationService} from "./Services/notification.service";
import { NavBarComponent } from './Components/NavBar/navbar.component';
import { HeaderComponent } from './Components/Header/header.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { NotificationComponent } from './Notification/notification.component';
import { LoginComponent } from './Components/Login/login.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'my-app',
    templateUrl: './app.component.html',
    imports: [NavBarComponent, HeaderComponent, NgClass, NotificationComponent, RouterOutlet, LoginComponent, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {

  private readonly tools               = inject(ToolsBoxService);
  private readonly notificationService = inject(NotificationService);
  private readonly router              = inject(Router);
  private readonly destroyRef          = inject(DestroyRef);

  // Signals from ToolsBoxService (field initializers work with inject())
  readonly containsTabs     = this.tools.containsTabs;
  readonly actionInProgress = this.tools.actionInProgress;
  readonly isLoggedIn       = this.tools.isLoggedIn;

  // NotificationService still uses Observables
  message: Observable<string>;
  type: Observable<string>;

  constructor() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationEnd && document.getElementById('body-content') != null) {
        document.getElementById('body-content').scrollTop = 0;
      }
    });
  }

  ngOnInit() {
    if (this.tools.checkUserisLoggedIn()) {
      this.router.navigate(['Dashboard']);
    }

    this.message = this.notificationService.message;
    this.type    = this.notificationService.type;
  }

  hideNotification() {
    this.notificationService.setMessage(null);
  }
}
